import Reveal from "@/components/Reveal";
import Tricolor from "@/components/Tricolor";
import { DoorOpen, Tags, Bot, Cake, PartyPopper } from "lucide-react";

const PROGRAM = [
  {
    time: "10:00",
    icon: DoorOpen,
    title: "Inizio Evento & Benvenuto",
    details: "Apertura delle porte e accoglienza di tutti gli ospiti in sede.",
  },
  {
    time: "10:15",
    icon: Tags,
    title: "Prodotti Esposti & Promo del Giorno",
    details: "Essendo un Open Day, l'esposizione dei prodotti del mondo automotive resta aperta per tutta la giornata, fino a fine evento, con le PROMO dedicate.",
  },
  {
    time: "15:00",
    icon: Bot,
    title: "Talk «AI» nel mondo Automotive",
    details: "Un confronto su come l'intelligenza artificiale sta trasformando il settore automotive.",
  },
  {
    time: "16:00",
    icon: Cake,
    title: "Taglio della Torta & Brindisi",
    details: "Il momento celebrativo dei nostri 45 anni, tutti insieme.",
  },
  {
    time: "17:00",
    icon: PartyPopper,
    title: "Chiusura Evento & Saluti",
    details: "Grazie per essere stati con noi in questa giornata speciale.",
  },
];

const Timeline = () => (
  <section id="programma" className="border-t border-[#ECECEA] bg-[#F1F1EF] py-28 sm:py-36" data-testid="timeline-section">
    <div className="mx-auto max-w-6xl px-6">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#E30613]">Il Programma</p>
        <Tricolor className="mt-4" />
        <h2 className="mt-6 font-display text-2xl font-semibold uppercase tracking-[0.06em] text-[#232525] sm:text-3xl lg:text-4xl">
          Il programma <span className="text-[#E30613]">della giornata</span>
        </h2>
        <div className="mt-6 max-w-2xl space-y-3 text-lg font-light leading-relaxed text-[#5B5D5D]">
          <p>Durante tutta la giornata: buffet per gli ospiti, animazione dedicata ai bambini ed esposizione dei prodotti del mondo automotive.</p>
          <p>Nell'RSVP potete indicare la fascia oraria in cui preferite partecipare.</p>
        </div>
      </Reveal>

      <div className="relative mt-16">
        <div className="absolute bottom-0 left-[19px] top-0 w-px bg-gradient-to-b from-[#E30613]/60 via-[#E30613]/20 to-transparent sm:left-1/2" />
        <div className="space-y-14">
          {PROGRAM.map((s, i) => (
            <Reveal key={s.time} delay={i * 0.1}>
              <div className={`relative flex flex-col gap-6 pl-14 sm:w-1/2 sm:pl-0 ${i % 2 === 0 ? "sm:pr-14 sm:text-right" : "sm:ml-auto sm:pl-14"}`} data-testid={`timeline-item-${i + 1}`}>
                <div className={`absolute top-1 flex h-10 w-10 items-center justify-center rounded-full border border-[#E30613]/40 bg-white text-[#E30613] shadow-sm left-0 ${i % 2 === 0 ? "sm:-right-5 sm:left-auto" : "sm:-left-5"}`}>
                  <s.icon size={18} />
                </div>
                <div>
                  <p className="font-display text-lg font-semibold tracking-[0.1em] text-[#E30613]">h. {s.time}</p>
                  <h3 className="mt-2 font-display text-xl font-semibold uppercase tracking-[0.05em] text-[#232525]">{s.title}</h3>
                  <p className="mt-3 text-base font-light leading-relaxed text-[#5B5D5D]">{s.details}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Timeline;
